import React from "react";
import Layout from "../components/layout";
import { Link } from "react-router-dom";
import { HelpCircle, BookOpen, Headphones, FileText } from "lucide-react";

const guides = [
  {
    title: "Application Flow",
    description: "Step-by-step guide on how to apply, track status, and complete onboarding.",
    icon: <BookOpen className="w-10 h-10 text-blue-600" />,
    link: "/help/application-flow",
  },
  {
    title: "Help & Support",
    description: "Contact our team for issues, troubleshooting, or account-related support.",
    icon: <Headphones className="w-10 h-10 text-green-600" />,
    link: "/settings",
  },
  {
    title: "User Permissions Guidelines",
    description: "View detailed guidelines and policies for applications and training.",
    icon: <FileText className="w-10 h-10 text-purple-600" />,
    link: "/help/permissions-guide",
  },
  {
    title: "FAQs",
    description: "Find answers to the most commonly asked questions quickly.",
    icon: <HelpCircle className="w-10 h-10 text-orange-600" />,
    link: "/settings",
  },
];

const Settings = () => {
  return (
    <Layout>
      <div className="p-6">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">
          Help & Support Center
        </h1>
        <p className="text-gray-600 mb-8">
          Welcome to the support center. Here you can find all the resources,
          guides, and support to navigate the application process.
        </p>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {guides.map((item, idx) => (
            <Link
              to={item.link}
              key={idx}
              className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-1"
            >
              <div className="flex items-center mb-4">{item.icon}</div>
              <h2 className="text-lg font-semibold text-gray-900">
                {item.title}
              </h2>
              <p className="text-gray-600 mt-2 text-sm">{item.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Settings;